import React from "react";
import TreeRow from "./TreeRow";

function TreeContainer({
                           data,
                           idSelected,
                           onClickItem,
                           getLabel,
                           getFigli,
                           isFolder,
                           icona,
                           initEsploso = true,
                           vociClickDestro,
                           classiAggiuntive,
                           startOpen
                       }) {

    return (
        <div className={'ns-tree-div'}>
            {
                data.map((item, index) => {
                    return <TreeRow
                        key={index}
                        elemento={item}
                        idSelected={idSelected}
                        onClickItem={onClickItem}
                        getLabel={getLabel}
                        getFigli={getFigli}
                        isFolder={isFolder}
                        initEsploso={initEsploso}
                        icona={icona}
                        vociClickDestro={vociClickDestro}
                        classiAggiuntive={classiAggiuntive}
                        startOpen={startOpen}
                    >
                    </TreeRow>
                })
            }
        </div>
    )

}

export default TreeContainer;